import { getClassName } from 'src/Core/utility/jsx';
import styles from './common.module.scss';

const CommonLandingContainer = ({ className, children }) => {
  return <div className={getClassName([styles.container, className])}>{children}</div>;
};

export default CommonLandingContainer;

export const LandingHorizontalBlock =  ({ id, className, children }) => {
  return <div id={id ?? ''} className={getClassName([styles.horizontalBlock, className])}>{children}</div>;
};
